import { useTheme } from '@emotion/react';
export default function () {
    return useTheme();
}
//# sourceMappingURL=use_theme.js.map